<template>
  <div>
    <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 200px)" highlight-current-row>
      <template>
        <el-table-column prop="className" label="班级名称" sortable="custom" show-overflow-tooltip width="150" />
        <el-table-column prop="sloganName" label="宣言" sortable="custom" show-overflow-tooltip />
        <el-table-column label="操作" width="210px" align="center" :resizable="false">
          <template #default="{ row }">
            <el-link @click="setSlogan(row)" :icon="row.sloganName === '' ? 'el-icon-setting' : 'el-icon-edit'" type="primary" :underline="false">{{
              row.sloganName === '' ? '设置' : '修改'
            }}</el-link>
          </template>
        </el-table-column>
      </template>
    </ele-data-table>
    <el-dialog title="提示" :visible.sync="showEdit" width="25%" @closed="editForm = {}" :destroy-on-close="true" :lock-scroll="false">
      <el-form :model="editForm" ref="editForm" label-width="82px" @keyup.enter.native="saveGeneral">
        <el-form-item label="宣言内容:" prop="sloganName">
          <el-input
            type="textarea"
            v-model="editForm.sloganName"
            rows="2"
            placeholder="请输入宣言内容（最多20个字）"
            maxlength="20"
            show-word-limit
            clearable
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEdit = false">取 消</el-button>
        <el-button type="primary" @click="saveSlogan">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { setClassSlogan } from '@/config/api';

  export default {
    name: 'ClassList',
    data() {
      return {
        table: {
          // 表格配置
          url: '/slogan/getClassSloganListByGrade',
          where: {},
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        choose: [],
        showEdit: false,
        editForm: {},
      };
    },
    methods: {
      setSlogan(row) {
        this.editForm = Object.assign({}, row);
        this.showEdit = true;
      },
      saveSlogan() {
        let formData = new FormData();
        for (let key in this.editForm) {
          if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
            formData.append(key, this.editForm[key]);
          }
        }
        setClassSlogan(formData).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '成功' });
            this.$refs.table.reload();
            this.showEdit = false;
          }
        });
      },
    },
  };
</script>

<style scoped></style>
